import React, { useEffect, useState } from 'react';
import { User, Mail, Phone, X } from 'lucide-react';
import { useWizard } from '../../Contexts/WizardContext';
import { Button } from '../General/Button';
import Input from '../General/Input';
import Loader from '../General/Loader';
import { findOrCreateContact } from '../../api/endpoints';

const requiredFileds = ['firstName', 'lastName', 'email', 'phone']

export default function ContactInfo () {
  const { updateFormData, nextStep, previousStep, formData } = useWizard();
  const [isLoading, setIsLoading] = useState(false);

  // do not pre-fill customer data:
  const [contactData, setContactData] = useState(null)
  const [isSaveButtonBlocked, setIsSaveButtonBlocked] = useState(true)
  // const [contactData, setContactData] = useState(formData?.contactData || null)
  // const [isSaveButtonBlocked, setIsSaveButtonBlocked] = useState(formData?.contactData ? false : true)

  useEffect(() => {
    if (!contactData) return; // Guard clause

    let toBlockSaveButton = false
    requiredFileds.forEach(fieldName => {
      if (!contactData[fieldName] || contactData[fieldName] == '') {
        toBlockSaveButton = true
      }
    })
    setIsSaveButtonBlocked(toBlockSaveButton)
  }, [contactData])
  
  const onSubmit = async () => {
    setIsLoading(true)
    if (!formData.jobsiteData.jobsite_data.contact_found) {
      try {
        await findOrCreateContact({contactData, jobsiteId: formData.jobsiteData.jobsite_data.jobsiteId})
      } catch(e) {
        console.log('something went wrong while searching HS contact', e)
      }
    }
    updateFormData(val => {
      return {
        ...val,
        contactData: contactData
      }
    })
    setIsLoading(false)
    nextStep()
  };


  const onFormDataChange = (value, fieldName) => {
    setContactData(val => {
      return {
        ...val,
        [fieldName]: value
      }
    })
  }

  const handleConfirmFoundUser = () => {
    const contact = formData.jobsiteData.jobsite_data.contact_data
    setContactData({
      firstName: contact.firstname,
      lastName: contact.lastname,
      email: contact.email,
      phone: contact.phone
    })
    setHideFoundUser(true)
  };
  const resetFoundUser = () => {
    setHideFoundUser(true)
  }
  
  const contactConfirmation = () => {  
    const contact = formData.jobsiteData.jobsite_data.contact_data
    return (
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-blue-50 border border-blue-200 rounded-lg px-6 py-4 gap-3">
        <p className="text-gray-800 text-base">
          We found a contact for this property, is it you: <span className="font-semibold">{contact.firstname} {contact.lastname}</span>?
        </p>
        <div className="flex items-center gap-2 sm:ml-4 shrink-0">
          <button
            onClick={handleConfirmFoundUser}
            className="flex-1 sm:flex-none bg-green-600 hover:bg-green-700 text-white font-medium px-6 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            Yes, it's me
          </button>
          <button
            onClick={resetFoundUser}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium p-2 rounded-lg transition-colors"
          >
            <X />
          </button>
        </div>
      </div>
    );
  };
  
  const [hideFoundUser, setHideFoundUser] = useState(false)
  return (
    <div className="w-full max-w-2xl mx-auto p-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
          Contact Information
        </h2>
        <p className="text-gray-600">We'll use this to confirm your appointment</p>
        {/* {formData.jobsiteData.jobsite_data.contact_found && !hideFoundUser ? contactConfirmation() : ''} */}
      </div>

      <Loader isLoading={isLoading} >
        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              label="First Name"
              id="firstName"
              onChange={onFormDataChange}
              parentValue={contactData?.firstName || null}
              placeholder="John"
              icon={<User className=" w-5 h-5" />}
            />

            <Input
              label="Last Name"
              id="lastName"
              onChange={onFormDataChange}
              parentValue={contactData?.lastName || null}
              placeholder="Doe"
              icon={<User className=" w-5 h-5" />}
            />
          </div>

          <Input
            label="Email Address"
            id="email"
            type='email'
            onChange={onFormDataChange}
            parentValue={contactData?.email || null}
            placeholder="john.doe@example.com"
            icon={<Mail className=" w-5 h-5" />}
          />

          <Input
            label="Phone Number"
            id="phone"
            type='tel'
            onChange={onFormDataChange}
            parentValue={contactData?.phone || null}
            placeholder="(555) 123-4567"
            icon={<Phone className=" w-5 h-5" />}
          />
          <div className="flex gap-4">
            <Button
              label='Back'
              isDisabled={false}
              onClick={previousStep}
            />
            <Button
              label='Continue'
              isDisabled={isSaveButtonBlocked}
              onClick={onSubmit}
              primary
            />
          </div>
        </div>
      </Loader>
    </div>
  );
};